import { Box, styled } from '@mui/material';

export const TitleTextWrapper = styled(Box)({
  fontSize: 14,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '25px'
});

export const TitleText = styled(Box)({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  paddingRight: '5px'
});

export const TitleStatusWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: '6px'
});

export const TitleStatusText = styled(Box)({
  marginLeft: '5px',
  color: 'rgba(51, 51, 51, 1)',
  fontSize: '12px'
});
